import { useSnackbar } from "notistack";
import { Box, Button, FormControl, Grid, Paper, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { Panel } from "primereact/panel";



import { Link, useNavigate } from "react-router-dom";
import { Acompanhamento, ISacompanhamento } from "../../../types/processo/Acompanhamento";
import errorFormat from "../../../utils/errorFormat";
import configUrls from "../../../config/configUrls";
import TxtGrupo from "../../autoComplete/TxtGrupo";
import { Grupo, ISgrupo } from "../../../types/grupo/Grupo";
import { useCreateAcompanhamentoMutation } from "./acompanhamentoApiSlice";
import { AcompanhamentoDTO } from "../../../types/processo/AcompanhamentoDTO";

import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";



export const ProcessoAcompanhamentoCreate = () => {

    const [acompanhamento, setAcompanhamento] = useState<Acompanhamento>(ISacompanhamento);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [createAcompanhamento, status] = useCreateAcompanhamentoMutation();
    const navigate = useNavigate();



    //ler do RTK o processo selecionado    
    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);

    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo foi previamente selecionado");
            window.location.href = configUrls.PROCESSO_LIST_RT
        } else {
            setAcompanhamento((prev) => ({
                ...prev,
                processo: processoSelecionado
            }));
        }
    }, [processoSelecionado]);






    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        const cursorPosition = e.target.selectionStart;

        setAcompanhamento((prev) => ({
            ...prev,
            [name]: value.toUpperCase(),
        }));

        // Aguarde até que o DOM seja atualizado
        setTimeout(() => {
            const input = e.target;
            input.setSelectionRange(cursorPosition, cursorPosition);
        }, 0);
    };

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        if (!acompanhamento.processo.id) {
            enqueueSnackbar("Processo inválido!", { variant: "error" })
            return;
        }

        if (!acompanhamento.grupoAcompanhamento?.id) {
            enqueueSnackbar("Selecione o grupo!", { variant: "error" })
            return;
        }

        if (!acompanhamento.descricao || acompanhamento.descricao.length == 0) {
            enqueueSnackbar("Preencha a Descrição!", { variant: "error" })
            return;
        }


        const params: AcompanhamentoDTO = {
            grupoAcompanhamentoID: acompanhamento.grupoAcompanhamento?.id,
            processoId: acompanhamento.processo.id,
            descricao: acompanhamento.descricao,
        }


        await createAcompanhamento(params);
    }

    useEffect(() => {
        if (status.isError) {
            enqueueSnackbar("Registro não incluído!", { variant: "error" })
            const erroReturn: string = errorFormat(status);
            enqueueSnackbar(erroReturn, { variant: "error" })
        }

        if (status.isSuccess) {
            enqueueSnackbar("Registro incluído!", { variant: "success" })
            navigate(configUrls.PROCESSO_ACOMPANHAMENTO_LIST_RT);
        }
    }, [status]);

    const handleSearchGrupoChange = (par: Grupo | null) => {
        setAcompanhamento((prev) => ({
            ...prev,
            grupoAcompanhamento: par ? {
                ...prev.grupoAcompanhamento,
                id: par.id || "",
                nome: par.nome || "",

            } : null // Se parOrgao for null, deixa o orgao como null
        }));
    };


    return (
        <>

            <Paper>



                <Box display="flex" justifyContent="space-between" mb={2}>

                    <Typography variant="h6" color="secondary" component="h1" sx={{ padding: 2 }}>
                        Novo Acompanhamento Especial
                    </Typography>
                    <Box display="flex" justifyContent="flex-end" padding={3}>
                        <Button
                            variant="contained"
                            color="secondary"
                            component={Link}
                            to={configUrls.GRUPO_ACOMPANHAMENTO_CREATE}
                        >
                            Novo Grupo
                        </Button>
                    </Box>
                </Box>



                <Box mt={2} p={2}>

                    <form onSubmit={handleSubmit} method='POST'>

                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <FormControl fullWidth>
                                        <TxtGrupo
                                            required
                                            value={acompanhamento.grupoAcompanhamento}
                                            handleSearchChange={handleSearchGrupoChange}
                                        />
                                    </FormControl>
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <TextField
                                        required
                                        label="Observação"
                                        name="descricao"
                                        onChange={handleChange}
                                        multiline
                                        rows={3}
                                        size="small"
                                        inputProps={{ maxLength: 255 }}
                                        value={acompanhamento.descricao} />
                                </FormControl>
                            </Grid>

                            <Grid item xs={12}>
                                <Box display="flex" gap={2}>

                                    <Button
                                        type="submit"
                                        variant="contained"
                                        color="secondary"
                                    >
                                        Gravar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        component={Link}
                                        to={configUrls.PROCESSO_ACOMPANHAMENTO_LIST_RT}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>

                    </form>



                </Box>




            </Paper>










        </>







    );










};

/*
 <AcompanhamentoTurmaForm
                    acompanhamentoTurma={acompanhamentoTurmaState}
                    isdisabled={status.isLoading}
                    isLoading={status.isLoading}
                    handleSubmit={handleSubmit}
                    handleChange={handleChange}
                />
*/